import type { ExteriorMaterialGeometry } from "building-types/geometry/exteriorMaterialGeometry";
import type { ExteriorMaterial } from "building-types/materials/exteriorMaterialTypes";
import type { InteriorMaterial } from "building-types/materials/interiorPaletteTypes";
import type {
  ExteriorMaterialOverride,
  InteriorMaterialOverride,
  MaterialSrcOverride,
} from "building-types/materials/materialTypes";
import type { ViewEntityDescriptor } from "building-types/views/viewEntityTypes";
import type { MaterialSrc } from "common/materials/materialSrc";
import { UVGeneration, type UVTransformation } from "geom/uv";

export function exteriorMaterialGeometryNew(): ExteriorMaterialGeometry {
  return {
    materialBreps: [],
    materialExtrusions: [],
    materialFaces: [],
  };
}

export function exteriorMaterialOverrideNew(
  exteriorMaterial: ExteriorMaterial | undefined,
  uvGen: UVGeneration = UVGeneration.NONE,
  viewEntityDescriptor?: ViewEntityDescriptor,
  materialTransformation?: UVTransformation,
  exportComponentName?: string,
): ExteriorMaterialOverride {
  return {
    exteriorMaterial,
    uvGen,
    materialTransformation,
    viewEntityDescriptor,
    exportComponentName,
  };
}

export function interiorMaterialOverrideNew(
  interiorMaterial: InteriorMaterial,
  uvGen: UVGeneration = UVGeneration.NONE,
  viewEntityDescriptor?: ViewEntityDescriptor,
  exportComponentName?: string,
): InteriorMaterialOverride {
  return {
    interiorMaterial,
    uvGen,
    viewEntityDescriptor,
    exportComponentName,
  };
}

export function materialSourceOverrideNew(
  materialSrc: MaterialSrc,
  uvGen = UVGeneration.NONE,
  exportComponentName?: string,
): MaterialSrcOverride {
  return {
    materialSrc,
    uvGen,
    viewEntityDescriptor: undefined,
    exportComponentName,
  };
}
